// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "chartkick/chart.js"

// ── Sidebar toggle (mobile) ──────────────────────────────
document.addEventListener("turbo:load", initSidebar);
document.addEventListener("DOMContentLoaded", initSidebar);

function initSidebar() {
  const btn = document.getElementById("hamburger-btn");
  const sidebar = document.getElementById("sidebar");
  const overlay = document.getElementById("sidebar-overlay");
  if (!btn || !sidebar) return;

  if (btn.dataset.wired) return;
  btn.dataset.wired = "1";

  btn.addEventListener("click", function() {
    const isOpen = sidebar.classList.toggle("open");
    if (overlay) overlay.classList.toggle("open");
    btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
    btn.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
  });

  if (overlay) {
    overlay.addEventListener("click", function() {
      sidebar.classList.remove("open");
      overlay.classList.remove("open");
    });
  }

  sidebar.querySelectorAll(".sidebar__link").forEach(function(link) {
    link.addEventListener("click", function() {
      sidebar.classList.remove("open");
      if (overlay) overlay.classList.remove("open");
    });
  });
}

// ── Clickable table rows (data-href) ────────────────────
document.addEventListener("turbo:load", initClickableRows);
document.addEventListener("DOMContentLoaded", initClickableRows);

function initClickableRows() {
  document.querySelectorAll("tr[data-href]").forEach(function(row) {
    if (row.dataset.rowWired) return;
    row.dataset.rowWired = "1";
    row.addEventListener("click", function(e) {
      if (e.target.closest("a, button, input, select, textarea")) return;
      window.location = row.dataset.href;
    });
  });
}
